import Store from "../../../../Store/Store";

class FinancialStatementStatusContainer {
  public pickIdFromLabel(label) {
    const financialStatementStatus = Store.getConfigurator().getState().globalTypes?.FinancialStatementStatuses;
    for(const key in financialStatementStatus) {
      if (financialStatementStatus?.[key]?.label?.toLowerCase() === label?.toLowerCase()) {
        return financialStatementStatus?.[key]?.id
      }
    }
  }
}

export default new FinancialStatementStatusContainer();
